import React from 'react';
import Button from '@material-ui/core/Button';
import ChatBubbleOutlineIcon from '@material-ui/icons/ChatBubbleOutline';
import StyleIcon from '@material-ui/icons/Style';
import Tooltip from '@material-ui/core/Tooltip';
import ModalHead from './ModalHead';
import {Play} from "./Inc";
import {Styles} from './Styles';

interface Props {
    play:Play,
    close():void,
}

const Result = (props:Props)=> {
    const classes = Styles.base();
    const text = props.play.name + "は" + props.play.lover + "を追い続ける～24Girls #レトロインク";
    const tweet_url = "https://twitter.com/intent/tweet?url=https%3A%2F%2Fgoisagi.retro-ink.com%2Fgirls%2F"+props.play.gid+"&text="+encodeURIComponent(text);

    return (
        <div id="result" className={classes.modalRoot}>
            <ModalHead close={props.close}/>
            <div style={{fontSize:"300%",textAlign:"center"}}>
                <span className={classes.withIcon}><StyleIcon style={{fontSize:"130%"}}/>24Girls</span>
            </div>
            <div style={{textAlign:"center",marginBottom:"1em"}}>
                {props.play.name}は{props.play.lover}を追い続ける
            </div>
            <div style={{textAlign:"center",marginBottom:"4em"}}>
                - 記録　{props.play.turn}時限 -
            </div>

            <div style={{textAlign:"center"}}>
                <a href={tweet_url} target="_blank" className="tw" rel="noopener noreferrer" style={{textDecoration:"none"}}><Tooltip title="ツイートする"><Button
                    variant="contained"
                    className={classes.tweetButton}
                    color="secondary"
                ><ChatBubbleOutlineIcon style={{marginRight:"0.5em"}}/> tweet</Button></Tooltip></a>
            </div>
            <div className={classes.modalBottom}>
                <Button variant="contained" color="primary" style={{width:"100%"}} onClick={props.close}>NEW GAME</Button>
            </div>
        </div>
    );
}

export default Result;
